module.exports = __webpack_public_path__ + "static/media/logo.74f0e63a.svg";